import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Shell } from '@/components/layout/Shell';
import { LoginPage } from '@/features/auth/LoginPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { RequestsPage } from '@/features/requests/RequestsPage';
import { CustomersPage } from '@/features/customers/CustomersPage';
import { CustomerDetailPage } from '@/features/customers/CustomerDetailPage';
import { PaymentsPage } from '@/features/payments/PaymentsPage';
import { BanksPage } from '@/features/banks/BanksPage';
import { MessagesPage } from '@/features/messages/MessagesPage';
import { NotificationsLogPage } from '@/features/notifications/NotificationsLogPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { ProtectedRoute } from './ProtectedRoute';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: (
      <ProtectedRoute>
        <Shell />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/requests', element: <RequestsPage /> },
      { path: '/requests/:section', element: <RequestsPage /> },
      { path: '/customers', element: <CustomersPage /> },
      { path: '/customers/:id', element: <CustomerDetailPage /> },
      { path: '/payments', element: <PaymentsPage /> },
      { path: '/banks', element: <BanksPage /> },
      { path: '/messages', element: <MessagesPage /> },
      { path: '/notifications-log', element: <NotificationsLogPage /> },
      { path: '/settings', element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/dashboard" replace /> },
]);
